import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

import { DynamicSurvey, NotFound } from 'pages';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NotFound title={'Survey not found'} />} />
        <Route path="/survey/:id" element={<DynamicSurvey />} />
        <Route path="/survey/:id/:question/:value" element={<DynamicSurvey />} />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
